import React, { useEffect } from "react";
import Layout from "../../Layout";
import HeaderOrg from "../HeaderOrg";
import { Link } from "react-router-dom";

const UploadOrgSuccess = () => {
  useEffect(() => {
    const heading = document.querySelector("h1.lg-msg");
    if (heading) {
      heading.setAttribute("tabindex", "-1");
      heading.focus();
    }
  }, []);

  return (
    <Layout>
      <HeaderOrg />
      <main className="layout-container">
        <div 
            className="container ctr sp-pad1"
            tabIndex="-1"
        >
          <div className="bi-success-check">
            <i className="bi bi-check2-circle" aria-hidden="true"></i>
          </div>
          <h1 className="lg-msg">
            Organization upload has started successfully.
          </h1>
          <div className="text-size6 spacer-margin3">
            <p>
              All organizations will be added as soon as possible, depending on the number of organizations being processed. <br />
              To check the current list, please use the button below.
            </p>
          </div>
          <Link to={"/organizations"} className="btn btn-primary">
            Manage Organizations
          </Link>
        </div>
      </main>
    </Layout>
  );
};

export default UploadOrgSuccess;
